import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useImpersonatedClient } from '../../hooks/useImpersonatedClient';

interface AdminRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Guard component that prevents access to admin routes when impersonating a client.
 * When impersonating, admins should see the client's interface, not admin interface.
 */
const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const { user } = useAuth();
  const { isImpersonating } = useImpersonatedClient();

  // If impersonating, redirect to dashboard (client view)
  if (isImpersonating) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not an admin, redirect to dashboard
  const isAdmin = user?.role === 'admin' || user?.role === 'admin-testing';
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
